/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.ImgSize[_ngcontent-%COMP%]{\n    height: 38px !important;\n}\n.new-icon[_ngcontent-%COMP%] {\n	height: 16px;\n	width: 39px;\n	color: #FFFFFF;\n	font-family: Poppins;\n	font-size: 12px;\n    line-height: 16px;\n    padding: 0px 5px;\n}\n.rectangle[_ngcontent-%COMP%] {\n	height: 16px;\n	width: 48px;\n	border: 1px solid #FFFFFF;\n	border-radius: 2px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zaGFyZWQvdWkvbW9iaWxlLWhlYWRlci9tb2JpbGUtaGVhZGVyLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL3NoYXJlZC91aS9tb2JpbGUtaGVhZGVyL21vYmlsZS1oZWFkZXIuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/mobile-header/mobile-header.component.css.shim.ngstyle.ts